module.exports = __webpack_public_path__ + "static/img/df1d9da53e049fc0e0856f0c6e6da276.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_active_04.png
// module id = HK5y
// module chunks = 1